let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8HTC7")).then(() => parcelRequire('lYh3a'));